(() => {
  class ServiceDetailController {
    /**
     * Services Controller
     * @memberof pims
     * @ngdoc controller
     * @param {service} $stateParams - URL Variable Interface
     * @param {service} Services - Service Interface
     */
    constructor($stateParams, Services) {
      'ngInject';

      Object.assign(this, {
        $stateParams,
        Services
      });
      this.init();
    }
    /**
     * Load all services and assign to view
     */


    init() {
      this.Services.fetch(this.$stateParams.serviceId)
        .then(({ data: service }) => {
          this.service = service;
        });
    }

  }

  ServiceDetailController.$inject = ["$stateParams", "Services"];
  angular.module('pims').controller('ServiceDetailController', ServiceDetailController);
})();
